var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwoLoveHearts1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "90px",
    height: "90px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 90 90",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n   \n    .fil0 {fill:black}\n\n  "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M22 19c1,0 1,0 2,0 -7,2 -11,6 -12,13 -1,5 -7,3 -4,-3 3,-7 8,-10 14,-10l0 0zm25 -4c-4,0 -9,3 -13,8 -5,-7 -12,-9 -18,-7 -6,2 -12,9 -12,16 0,8 5,15 10,22 6,6 13,11 19,14l1 0 0 0c6,-3 13,-8 19,-15 2,-4 5,-7 7,-11 -1,-1 -2,-2 -3,-2 -1,4 -4,8 -7,12 -4,5 -9,9 -14,11l0 0 -1 0c-4,-2 -9,-6 -14,-11 -4,-5 -7,-10 -7,-16 0,-5 4,-10 9,-12 4,-1 9,0 13,5 3,-3 7,-5 10,-5 0,0 1,0 1,0 0,0 0,0 0,0 1,0 2,0 2,0 1,0 2,0 2,1 0,0 0,0 1,0 1,0 2,0 3,0 3,0 5,2 7,4 0,-7 -5,-12 -10,-13 -1,-1 -2,-1 -3,-1 0,0 0,0 -1,0 0,0 0,0 -1,0zm4 12c-5,1 -10,3 -12,8 -3,6 -2,13 -1,20 1,2 1,3 1,4 2,-1 3,-2 5,-4 -1,-5 -1,-9 1,-13 2,-4 6,-6 9,-6 1,0 1,1 2,1 4,0 8,4 9,9 3,-2 7,-2 9,0 0,0 1,0 1,0 0,0 0,0 0,0 1,1 1,1 2,1 3,3 4,8 2,12 -3,4 -7,8 -12,10 -5,2 -11,3 -15,3l-1 0 0 -1c-2,-2 -3,-5 -5,-8 -1,1 -2,2 -4,3 2,3 4,6 5,8l1 1 0 0c6,0 13,-1 20,-4 7,-3 13,-8 16,-13 3,-6 2,-12 -3,-16 0,-1 -1,-1 -1,-2 0,0 -1,0 -1,0 0,0 0,0 -1,0 -3,-2 -8,-2 -13,0 -1,-7 -6,-11 -11,-12 -1,-1 -2,-1 -3,-1zm3 6c1,0 2,1 2,1 -6,-2 -10,1 -12,6 -2,4 -6,0 -3,-5 4,-4 9,-5 13,-2l0 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwoLoveHearts1);
export default __webpack_public_path__ + "static/media/two-love-hearts-1.239967e4c3a979ac7b0a40a41ebec8cf.svg";
export { ForwardRef as ReactComponent };